// Exclude shared mailboxes, conference rooms, kiosk/resource accounts, and
// brand-named team aliases (e.g. TEAMHONDA, TEAMNISSAN) from employee
// selection. Entra lists these alongside real users; they must never appear
// in the EmployeePicker or any downstream picker.
const RESOURCE_KEYWORDS =
  /\b(room|conference|conf|meeting|lobby|kitchen|break|board|resource|mailbox|corporate)\b/i;

export function isPersonAccount(employee: { displayName: string; mail?: string | null }): boolean {
  if (RESOURCE_KEYWORDS.test(employee.displayName)) return false;
  if (/^team/i.test(employee.displayName)) return false;
  const mailLocal = ((employee.mail ?? '').split('@')[0] ?? '').toLowerCase();
  if (mailLocal.startsWith('team')) return false;
  return true;
}
